"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomOrderedList = void 0;
const extension_ordered_list_1 = require("@tiptap/extension-ordered-list");
const names_1 = require("./utils/names");
exports.CustomOrderedList = extension_ordered_list_1.OrderedList.extend({
    name: names_1.CustomOrderedListExtensionName,
    addOptions() {
        return {
            itemTypeName: names_1.CustomListItemExtensionName,
            HTMLAttributes: {},
            keepMarks: true,
            keepAttributes: true,
        };
    },
});
//# sourceMappingURL=custom-ordered-list.js.map